import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, FoundationProperty } from '@tyler-components-web/core';
import { IconAdapter } from './icon-adapter';
import { IconFoundation } from './icon-foundation';
import { ICON_CONSTANTS } from './icon-constants';
var template = require('./icon.html');
var styles = require('./icon.css');
var IconComponent = /** @class */ (function (_super) {
    __extends(IconComponent, _super);
    function IconComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, ICON_CONSTANTS.elementName, template, styles);
        _this._foundation = new IconFoundation(new IconAdapter(_this));
        return _this;
    }
    Object.defineProperty(IconComponent, "observedAttributes", {
        get: function () {
            return [
                ICON_CONSTANTS.attributes.NAME,
                ICON_CONSTANTS.attributes.SRC,
                ICON_CONSTANTS.attributes.LAZY,
                ICON_CONSTANTS.attributes.EXTERNAL,
                ICON_CONSTANTS.attributes.EXTERNAL_TYPE,
                ICON_CONSTANTS.attributes.VIEWBOX
            ];
        },
        enumerable: true,
        configurable: true
    });
    IconComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'name');
        upgradeProperty(this, 'src');
        upgradeProperty(this, 'lazy');
        upgradeProperty(this, 'external');
        upgradeProperty(this, 'externalType');
        upgradeProperty(this, 'externalUrlBuilder');
        upgradeProperty(this, 'viewbox');
    };
    IconComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    IconComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    IconComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case ICON_CONSTANTS.attributes.NAME:
                this.name = newValue;
                break;
            case ICON_CONSTANTS.attributes.SRC:
                this.src = newValue;
                break;
            case ICON_CONSTANTS.attributes.LAZY:
                this.lazy = this.hasAttribute(ICON_CONSTANTS.attributes.LAZY);
                break;
            case ICON_CONSTANTS.attributes.EXTERNAL:
                this.external = this.hasAttribute(ICON_CONSTANTS.attributes.EXTERNAL);
                break;
            case ICON_CONSTANTS.attributes.EXTERNAL_TYPE:
                this.externalType = newValue;
                break;
            case ICON_CONSTANTS.attributes.VIEWBOX:
                this.viewbox = newValue;
                break;
        }
    };
    /** Forces a reload of the icon. */
    IconComponent.prototype.layout = function () {
        this._foundation.layout();
    };
    __decorate([
        FoundationProperty()
    ], IconComponent.prototype, "name", void 0);
    __decorate([
        FoundationProperty()
    ], IconComponent.prototype, "src", void 0);
    __decorate([
        FoundationProperty()
    ], IconComponent.prototype, "lazy", void 0);
    __decorate([
        FoundationProperty()
    ], IconComponent.prototype, "external", void 0);
    __decorate([
        FoundationProperty()
    ], IconComponent.prototype, "externalType", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], IconComponent.prototype, "externalUrlBuilder", void 0);
    __decorate([
        FoundationProperty()
    ], IconComponent.prototype, "viewbox", void 0);
    IconComponent = __decorate([
        CustomElement({
            name: ICON_CONSTANTS.elementName
        })
    ], IconComponent);
    return IconComponent;
}(HTMLElement));
export { IconComponent };
